import axios from "axios";

const token = window.localStorage.getItem("token");
const config = {
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        Authorization: `${token}`
    }
};

import constant from '../../../../constants.json';
const baseURL = process.env.REACT_APP_API_URL;

export const get_all_property_features = async () => {
    let response = await axios.get(baseURL + "/api/feature", config);
    return response.data.data;
}
export const get_all_property_features_for_organisation = async () => {
    let response = await axios.get(baseURL + "/api/property-features-listing", config);
    return response.data.data;
}
export const update_property_feature = async (property_feature_id,name) => {
    let response = await axios.patch(baseURL + "/api/feature/"+property_feature_id,{
        "feature_name": name,
      }, config);
    return response.data.data;
}
export const delete_property_feature = async (property_feature_id) => {
    let response = await axios.delete(baseURL + "/api/feature/"+property_feature_id, config);
    return response.data.data;
}